module.exports = __webpack_public_path__ + "img/question-mark.7bd5ff78.svg";